/* eslint-disable no-underscore-dangle */

import base64 from 'base-64';

// Method to decode user ID from profile token
export const getPrimaryIdentityIdFromProfileId = (profileId) => {
  try {
    // Currently, primaryIdentityId is straightforward decoded base64
    return base64.decode(profileId);
  } catch (e) {
    // Couldn't decode primaryIdentityId from profileId
  }
  return '';
};

// Method to encode user ID to profile token
export const getProfileIdFromPrimaryIdentityId = primaryIdentityId =>
  // Currently, profileId is straightforward base64 encode
  base64.encode(primaryIdentityId);

// Check profile for null activities
export const nullCheckActivities = profile => ({
  ...profile,
  bookings:
    profile.bookings &&
    profile.bookings.filter(
      b => !!b.ticket && !!b.ticket.race && !!b.ticket.event,
    ),
});

// Check profile and connections for null activities
export const nullCheckProfile = profile => ({
  ...nullCheckActivities(profile),
  privateConnections:
    profile.privateConnections &&
    profile.privateConnections.filter(connection => !!connection.user).map(connection => ({
      ...connection,
      user: nullCheckActivities(connection.user),
    })),
  publicConnections:
    profile.publicConnections &&
    profile.publicConnections.filter(connection => !!connection.user).map(connection => ({
      ...connection,
      user: nullCheckActivities(connection.user),
    })),
});



// WEBPACK FOOTER //
// ./app/src/components/ProfilePage/helpers/profile.js